/**
 * TODO: Move hex colors into css variables for p3 support
 */

const Chrome = (
  <svg
    aria-hidden="true"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ii_927_5781)">
      <g clipPath="url(#clip0_927_5781)">
        <path
          d="M1.58771 0V12.2727H6.06498L10.0002 5.45455H20.0002V0H1.58771Z"
          fill="#DB4437"
        />
        <path
          d="M1.58771 0V12.2727H6.06498L10.0002 5.45455H20.0002V0H1.58771Z"
          fill="url(#paint0_linear_927_5781)"
        />
        <path
          d="M6.17038 12.2272L1.64538 4.46582L1.57947 4.57946L6.07265 12.284L6.17038 12.2272Z"
          fill="black"
          fillOpacity="0.15"
        />
        <path
          d="M0 20.0003H9.51932L13.9375 15.5821V12.273H6.0625L0 1.87305V20.0003Z"
          fill="#0F9D58"
        />
        <path
          d="M0 20.0003H9.51932L13.9375 15.5821V12.273H6.0625L0 1.87305V20.0003Z"
          fill="url(#paint1_linear_927_5781)"
        />
        <path
          d="M13.8412 12.4208L13.7469 12.3662L9.38324 19.9969H9.51392L13.8435 12.4242L13.8412 12.4208Z"
          fill="#263238"
          fillOpacity="0.15"
        />
        <path
          d="M10.0006 5.45459L13.9381 12.2728L9.51996 20H20.0006V5.45459H10.0006Z"
          fill="#FFCD40"
        />
        <path
          d="M10.0006 5.45459L13.9381 12.2728L9.51996 20H20.0006V5.45459H10.0006Z"
          fill="url(#paint2_linear_927_5781)"
        />
        <path
          d="M9.9996 5.45459L13.9371 12.2728L9.51892 20H19.9996V5.45459H9.9996Z"
          fill="#FFCD40"
        />
        <path
          d="M9.9996 5.45459L13.9371 12.2728L9.51892 20H19.9996V5.45459H9.9996Z"
          fill="url(#paint3_linear_927_5781)"
        />
        <path
          d="M1.58691 0V12.2727H6.06419L9.99941 5.45455H19.9994V0H1.58691Z"
          fill="#DB4437"
        />
        <path
          d="M1.58691 0V12.2727H6.06419L9.99941 5.45455H19.9994V0H1.58691Z"
          fill="url(#paint4_linear_927_5781)"
        />
        <path
          d="M10 5.45459V7.83527L18.9091 5.45459H10Z"
          fill="url(#paint5_radial_927_5781)"
        />
        <path
          d="M0 19.9998H9.51932L11.9318 15.9089L13.9375 12.2726H6.0625L0 1.87256V19.9998Z"
          fill="#0F9D58"
        />
        <path
          d="M0 19.9998H9.51932L12.1023 15.5112L13.9375 12.2726H6.0625L0 1.87256V19.9998Z"
          fill="url(#paint6_linear_927_5781)"
        />
        <path
          d="M1.58771 4.59668L8.09339 11.1012L6.06384 12.2728L1.58771 4.59668Z"
          fill="url(#paint7_radial_927_5781)"
        />
        <path
          d="M9.52661 19.9884L11.9084 11.1021L13.938 12.2725L9.52661 19.9884Z"
          fill="url(#paint8_radial_927_5781)"
        />
        <path
          d="M10.0003 14.5455C12.5107 14.5455 14.5458 12.5104 14.5458 10C14.5458 7.48966 12.5107 5.45459 10.0003 5.45459C7.48996 5.45459 5.4549 7.48966 5.4549 10C5.4549 12.5104 7.48996 14.5455 10.0003 14.5455Z"
          fill="#F1F1F1"
        />
        <path
          d="M9.99995 13.6365C12.0083 13.6365 13.6363 12.0084 13.6363 10.0001C13.6363 7.99183 12.0083 6.36377 9.99995 6.36377C7.99164 6.36377 6.36359 7.99183 6.36359 10.0001C6.36359 12.0084 7.99164 13.6365 9.99995 13.6365Z"
          fill="#4285F4"
        />
        <path
          d="M10.0003 5.34082C7.48899 5.34082 5.4549 7.37491 5.4549 9.88628V9.99991C5.4549 7.48855 7.48899 5.45446 10.0003 5.45446H20.0003V5.34082H10.0003Z"
          fill="black"
          fillOpacity="0.2"
        />
        <path
          d="M13.9318 12.273C13.1455 13.6299 11.6818 14.5458 10 14.5458C8.31818 14.5458 6.85227 13.6299 6.06818 12.273H6.06364L0 1.87305V1.98668L6.06818 12.3867C6.85455 13.7435 8.31818 14.6594 10 14.6594C11.6818 14.6594 13.1455 13.7446 13.9318 12.3867H13.9375V12.273H13.9307H13.9318Z"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          opacity="0.1"
          d="M10.1133 5.45459C10.094 5.45459 10.0758 5.45686 10.0565 5.458C12.5406 5.48868 14.5452 7.50913 14.5452 10C14.5452 12.491 12.5406 14.5114 10.0565 14.5421C10.0758 14.5421 10.094 14.5455 10.1133 14.5455C12.6247 14.5455 14.6588 12.5114 14.6588 10C14.6588 7.48868 12.6247 5.45459 10.1133 5.45459Z"
          fill="black"
        />
        <path
          d="M13.9769 12.4204C14.3632 11.7522 14.5871 10.9795 14.5871 10.1522C14.5874 9.68602 14.5157 9.22262 14.3746 8.77832C14.4826 9.16696 14.5451 9.57377 14.5451 9.99764C14.5451 10.8249 14.3212 11.5976 13.9348 12.2658L13.9371 12.2704L9.51892 19.9976H9.65074L13.9769 12.4204Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M10 0.113636C15.5034 0.113636 19.9682 4.56023 20 10.0568C20 10.0375 20.0011 10.0193 20.0011 10C20.0011 4.47727 15.5239 0 10.0011 0C4.47841 0 0 4.47727 0 10C0 10.0193 0.00113639 10.0375 0.00113639 10.0568C0.0318182 4.56023 4.49659 0.113636 10 0.113636Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M10 19.8865C15.5034 19.8865 19.9682 15.4399 20 9.94336C20 9.96268 20.0011 9.98086 20.0011 10.0002C20.0011 15.5229 15.5239 20.0002 10.0011 20.0002C4.47841 20.0002 0 15.5229 0 10.0002C0 9.98086 0.00113639 9.96268 0.00113639 9.94336C0.0318182 15.4399 4.49659 19.8865 10.0011 19.8865H10Z"
          fill="black"
          fillOpacity="0.15"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_ii_927_5781"
        x={0}
        y="-0.235294"
        width={20}
        height="20.4706"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.235294" />
        <feGaussianBlur stdDeviation="0.235294" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_927_5781"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.235294" />
        <feGaussianBlur stdDeviation="0.235294" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_927_5781"
          result="effect2_innerShadow_927_5781"
        />
      </filter>
      <linearGradient
        id="paint0_linear_927_5781"
        x1="2.42521"
        y1="7.61591"
        x2="8.39112"
        y2="4.13068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A52714" stopOpacity="0.6" />
        <stop offset="0.66" stopColor="#A52714" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_927_5781"
        x1="11.6932"
        y1="17.7844"
        x2="5.06136"
        y2="13.8981"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#055524" stopOpacity="0.4" />
        <stop offset="0.33" stopColor="#055524" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_927_5781"
        x1="12.9438"
        y1="4.75004"
        x2="14.6143"
        y2="12.0569"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA6100" stopOpacity="0.3" />
        <stop offset="0.66" stopColor="#EA6100" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_927_5781"
        x1="12.9428"
        y1="4.75004"
        x2="14.6132"
        y2="12.0569"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA6100" stopOpacity="0.3" />
        <stop offset="0.66" stopColor="#EA6100" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_927_5781"
        x1="2.42441"
        y1="7.61591"
        x2="8.39032"
        y2="4.13068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A52714" stopOpacity="0.6" />
        <stop offset="0.66" stopColor="#A52714" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="paint5_radial_927_5781"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.56818 5.44891) scale(9.55455)"
      >
        <stop stopColor="#3E2723" stopOpacity="0.2" />
        <stop offset={1} stopColor="#3E2723" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="paint6_linear_927_5781"
        x1="11.6932"
        y1="17.7839"
        x2="5.06136"
        y2="13.8976"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#055524" stopOpacity="0.4" />
        <stop offset="0.33" stopColor="#055524" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="paint7_radial_927_5781"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1.57975 4.60463) scale(8.86818)"
      >
        <stop stopColor="#3E2723" stopOpacity="0.2" />
        <stop offset={1} stopColor="#3E2723" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint8_radial_927_5781"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.97775 10.0157) scale(9.98523)"
      >
        <stop stopColor="#263238" stopOpacity="0.2" />
        <stop offset={1} stopColor="#263238" stopOpacity={0} />
      </radialGradient>
      <clipPath id="clip0_927_5781">
        <rect width={20} height={20} rx={10} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const FireFox = (
  <svg
    aria-hidden="true"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_927_5847)">
      <path
        d="M19.011 6.71023C18.5898 5.69685 17.7355 4.60269 17.0665 4.25681C17.5436 5.18063 17.8747 6.17276 18.0481 7.19792L18.0499 7.21417C16.954 4.48315 15.0963 3.38023 13.5782 0.981835C13.5014 0.860539 13.4246 0.738994 13.3498 0.610696C13.3071 0.537418 13.2728 0.471393 13.2431 0.410621C13.1801 0.288713 13.1316 0.159878 13.0985 0.0267267C13.0985 0.0205825 13.0963 0.0146369 13.0923 0.0100242C13.0882 0.00541151 13.0826 0.00245454 13.0765 0.00171737C13.0705 7.85858e-05 13.0642 7.85858e-05 13.0582 0.00171737C13.057 0.00171737 13.055 0.00396821 13.0535 0.0044684C13.052 0.00496859 13.0487 0.00721943 13.0465 0.00821981L13.0502 0.00171737C10.6156 1.42725 9.78901 4.06574 9.71399 5.38624C8.74136 5.45292 7.81141 5.81121 7.04549 6.41437C6.96561 6.34671 6.88212 6.28343 6.79539 6.2248C6.57456 5.45174 6.56514 4.6336 6.76813 3.85566C5.87401 4.28877 5.07954 4.90279 4.43501 5.65884H4.43051C4.04636 5.17191 4.07337 3.5663 4.09538 3.23093C3.98174 3.2766 3.87326 3.33419 3.77176 3.40274C3.43264 3.64477 3.11562 3.91635 2.8244 4.2143C2.49255 4.55075 2.18946 4.91441 1.91831 5.30146V5.30296V5.3012C1.29521 6.18444 0.853213 7.18234 0.617826 8.23731L0.604821 8.30133C0.586564 8.38661 0.52079 8.81377 0.509535 8.90656C0.509535 8.91381 0.508035 8.92056 0.507285 8.92781C0.42244 9.36882 0.369864 9.81542 0.349976 10.2641V10.3141C0.354259 12.7396 1.26772 15.0754 2.91002 16.8604C4.55233 18.6454 6.80415 19.7498 9.22094 19.9556C11.6377 20.1615 14.0439 19.4538 15.9644 17.9723C17.8849 16.4908 19.1803 14.3431 19.5947 11.9532C19.6109 11.8282 19.6242 11.7044 19.6387 11.5781C19.8384 9.92791 19.6222 8.25404 19.01 6.70873L19.011 6.71023ZM7.83928 14.2981C7.88455 14.3198 7.92707 14.3433 7.97358 14.3641L7.98034 14.3684C7.93332 14.3458 7.8863 14.3224 7.83928 14.2981ZM18.0501 7.21692V7.20767L18.0519 7.21792L18.0501 7.21692Z"
        fill="url(#paint0_linear_927_5847)"
      />
      <path
        d="M19.0109 6.71026C18.5898 5.69688 17.7354 4.60272 17.0664 4.25684C17.5435 5.18066 17.8746 6.17278 18.0481 7.19794V7.20719L18.0498 7.21745C18.797 9.35551 18.689 11.6997 17.7482 13.7599C16.6373 16.1435 13.9493 18.5867 9.7402 18.4667C5.19349 18.3379 1.18699 14.9629 0.439211 10.5437C0.30291 9.84668 0.439211 9.4933 0.507737 8.92684C0.414265 9.36685 0.362102 9.81463 0.351929 10.2643V10.3144C0.356212 12.7399 1.26967 15.0757 2.91198 16.8607C4.55429 18.6456 6.8061 19.7501 9.2229 19.9559C11.6397 20.1617 14.0458 19.4541 15.9664 17.9725C17.8869 16.491 19.1822 14.3434 19.5966 11.9535C19.6129 11.8284 19.6262 11.7046 19.6407 11.5783C19.8403 9.92819 19.6242 8.25431 19.0119 6.70901L19.0109 6.71026Z"
        fill="url(#paint1_radial_927_5847)"
      />
      <path
        d="M19.0109 6.71026C18.5898 5.69688 17.7354 4.60272 17.0664 4.25684C17.5435 5.18066 17.8746 6.17278 18.0481 7.19794V7.20719L18.0498 7.21745C18.797 9.35551 18.689 11.6997 17.7482 13.7599C16.6373 16.1435 13.9493 18.5867 9.7402 18.4667C5.19349 18.3379 1.18699 14.9629 0.439211 10.5437C0.30291 9.84668 0.439211 9.4933 0.507737 8.92684C0.414265 9.36685 0.362102 9.81463 0.351929 10.2643V10.3144C0.356212 12.7399 1.26967 15.0757 2.91198 16.8607C4.55429 18.6456 6.8061 19.7501 9.2229 19.9559C11.6397 20.1617 14.0458 19.4541 15.9664 17.9725C17.8869 16.491 19.1822 14.3434 19.5966 11.9535C19.6129 11.8284 19.6262 11.7046 19.6407 11.5783C19.8403 9.92819 19.6242 8.25431 19.0119 6.70901L19.0109 6.71026Z"
        fill="url(#paint2_radial_927_5847)"
      />
      <path
        d="M14.2993 7.84794C14.3203 7.8627 14.3398 7.87745 14.3595 7.89221C14.1161 7.46047 13.813 7.06519 13.4592 6.71802C10.4456 3.70439 12.6696 0.18557 13.0445 0.00550206L13.0483 0C10.6136 1.42553 9.78706 4.06402 9.71204 5.38452C9.82508 5.37677 9.93712 5.36726 10.0527 5.36726C10.9164 5.36893 11.7644 5.59929 12.5103 6.03492C13.2562 6.47055 13.8734 7.09592 14.2993 7.84744V7.84794Z"
        fill="url(#paint3_radial_927_5847)"
      />
      <path
        d="M10.0577 8.45061C10.0417 8.6917 9.18992 9.52326 8.89206 9.52326C6.13602 9.52326 5.68835 11.1906 5.68835 11.1906C5.8104 12.5947 6.78877 13.7516 7.97146 14.3618C8.02548 14.3898 8.08025 14.4151 8.13502 14.4399C8.22989 14.4819 8.32476 14.5207 8.41963 14.5564C8.82553 14.7 9.25065 14.7821 9.68085 14.7997C14.5127 15.0263 15.448 9.02257 11.9615 7.27942C12.7839 7.1724 13.6168 7.37463 14.2986 7.84688C13.8727 7.09536 13.2555 6.46999 12.5096 6.03436C11.7637 5.59873 10.9158 5.36837 10.052 5.3667C9.93695 5.3667 9.82441 5.3762 9.71136 5.38396C8.73874 5.45064 7.80879 5.80893 7.04286 6.41209C7.19067 6.53714 7.35748 6.7042 7.70886 7.05058C8.36661 7.69857 10.0535 8.36983 10.0572 8.44861L10.0577 8.45061Z"
        fill="url(#paint4_radial_927_5847)"
      />
      <path
        d="M10.0577 8.45061C10.0417 8.6917 9.18992 9.52326 8.89206 9.52326C6.13602 9.52326 5.68835 11.1906 5.68835 11.1906C5.8104 12.5947 6.78877 13.7516 7.97146 14.3618C8.02548 14.3898 8.08025 14.4151 8.13502 14.4399C8.22989 14.4819 8.32476 14.5207 8.41963 14.5564C8.82553 14.7 9.25065 14.7821 9.68085 14.7997C14.5127 15.0263 15.448 9.02257 11.9615 7.27942C12.7839 7.1724 13.6168 7.37463 14.2986 7.84688C13.8727 7.09536 13.2555 6.46999 12.5096 6.03436C11.7637 5.59873 10.9158 5.36837 10.052 5.3667C9.93695 5.3667 9.82441 5.3762 9.71136 5.38396C8.73874 5.45064 7.80879 5.80893 7.04286 6.41209C7.19067 6.53714 7.35748 6.7042 7.70886 7.05058C8.36661 7.69857 10.0535 8.36983 10.0572 8.44861L10.0577 8.45061Z"
        fill="url(#paint5_radial_927_5847)"
      />
      <path
        d="M6.59134 6.0923C6.66987 6.14231 6.73464 6.18583 6.79141 6.2251C6.57058 5.45204 6.56117 4.63389 6.76415 3.85596C5.87003 4.28907 5.07556 4.90308 4.43103 5.65913C4.4783 5.65788 5.88432 5.63262 6.59134 6.0923Z"
        fill="url(#paint6_radial_927_5847)"
      />
      <path
        d="M0.437567 10.5439C1.1856 14.963 5.19185 18.3393 9.73855 18.4668C13.9476 18.5859 16.6361 16.1425 17.7466 13.7601C18.6873 11.6998 18.7954 9.35569 18.0482 7.21762V7.20837C18.0482 7.20111 18.0467 7.19686 18.0482 7.19911L18.0499 7.21537C18.3938 9.46046 17.2519 11.6345 15.4665 13.1076L15.4609 13.1201C11.9821 15.9536 8.6534 14.8292 7.98064 14.3706C7.93363 14.348 7.88661 14.3246 7.83959 14.3003C5.81158 13.3309 4.97352 11.4842 5.15358 9.89862C4.67218 9.90573 4.19905 9.77307 3.79151 9.51672C3.38397 9.26038 3.05952 8.89134 2.85747 8.45433C3.38987 8.1282 3.99692 7.94382 4.62077 7.91878C5.24461 7.89374 5.86448 8.02887 6.42131 8.31128C7.56906 8.83225 8.87507 8.8836 10.0602 8.45433C10.0564 8.37555 8.36954 7.70405 7.71179 7.05631C7.36041 6.70993 7.1936 6.54312 7.04579 6.41782C6.96591 6.35016 6.88243 6.28688 6.7957 6.22825C6.73818 6.18898 6.6734 6.14647 6.59562 6.09545C5.88861 5.63578 4.48258 5.66104 4.43607 5.66229H4.43156C4.04742 5.17535 4.07443 3.56975 4.09644 3.23438C3.9828 3.28005 3.87431 3.33764 3.77282 3.40619C3.4337 3.64822 3.11667 3.91979 2.82546 4.21774C2.49242 4.55325 2.18808 4.91607 1.91562 5.3024V5.3039V5.30215C1.29252 6.18539 0.850521 7.18329 0.615133 8.23825C0.610381 8.25801 0.266002 9.76357 0.435816 10.5444L0.437567 10.5439Z"
        fill="url(#paint7_radial_927_5847)"
      />
      <path
        d="M13.459 6.71761C13.8128 7.06516 14.1159 7.46087 14.3593 7.89305C14.4126 7.93331 14.4624 7.97333 14.5046 8.01209C16.7022 10.0378 15.5508 12.9014 15.465 13.104C17.2502 11.6332 18.3911 9.45763 18.0485 7.21179C16.952 4.47826 15.0923 3.37535 13.5768 0.976952C13.5 0.855657 13.4232 0.734111 13.3484 0.605813C13.3057 0.532535 13.2714 0.466511 13.2417 0.405738C13.1787 0.283831 13.1302 0.154995 13.0971 0.0218439C13.0971 0.0156997 13.0949 0.0097541 13.0909 0.0051414C13.0868 0.000528701 13.0812 -0.00242828 13.0751 -0.00316545C13.0691 -0.00480423 13.0628 -0.00480423 13.0568 -0.00316545C13.0556 -0.00316545 13.0536 -0.000914601 13.0521 -0.000414413C13.0506 8.57743e-05 13.0473 0.00233662 13.0451 0.00333699C12.6702 0.181154 10.4466 3.70222 13.4602 6.71335L13.459 6.71761Z"
        fill="url(#paint8_radial_927_5847)"
      />
      <path
        d="M14.5043 8.01315C14.462 7.97439 14.4122 7.93437 14.359 7.8941C14.3392 7.87935 14.3197 7.86459 14.2987 7.84984C13.6169 7.37759 12.784 7.17536 11.9616 7.28238C15.4479 9.02553 14.5125 15.0278 9.68095 14.8027C9.25075 14.785 8.82562 14.703 8.41973 14.5594C8.32486 14.5238 8.22999 14.485 8.13512 14.4428C8.08035 14.4178 8.02558 14.3928 7.97156 14.3648L7.97831 14.369C8.65206 14.829 11.9798 15.9526 15.4586 13.1186L15.4641 13.1061C15.5509 12.9035 16.7023 10.0399 14.5038 8.01415L14.5043 8.01315Z"
        fill="url(#paint9_radial_927_5847)"
      />
      <path
        d="M5.68842 11.1892C5.68842 11.1892 6.13583 9.52179 8.89212 9.52179C9.18998 9.52179 10.0425 8.69023 10.0578 8.44914C8.8727 8.8784 7.56669 8.82706 6.41894 8.30608C5.86211 8.02367 5.24224 7.88855 4.61839 7.91359C3.99455 7.93863 3.3875 8.123 2.8551 8.44914C3.05715 8.88615 3.3816 9.25518 3.78914 9.51153C4.19668 9.76787 4.66981 9.90053 5.15121 9.89343C4.97165 11.4783 5.80946 13.3247 7.83722 14.2951C7.88249 14.3168 7.925 14.3403 7.97152 14.3611C6.78783 13.7496 5.81046 12.5932 5.68842 11.1899V11.1892Z"
        fill="url(#paint10_radial_927_5847)"
      />
      <path
        d="M19.0112 6.71023C18.59 5.69685 17.7357 4.60269 17.0667 4.25681C17.5438 5.18063 17.8749 6.17276 18.0483 7.19792L18.0501 7.21417C16.9542 4.48315 15.0965 3.38023 13.5784 0.981835C13.5016 0.860539 13.4249 0.738994 13.3501 0.610696C13.3073 0.537418 13.2731 0.471393 13.2433 0.410621C13.1803 0.288713 13.1318 0.159878 13.0987 0.0267267C13.0988 0.0205825 13.0966 0.0146369 13.0925 0.0100242C13.0884 0.00541151 13.0828 0.00245454 13.0767 0.00171737C13.0708 7.85859e-05 13.0644 7.85859e-05 13.0585 0.00171737C13.0572 0.00171737 13.0552 0.00396821 13.0537 0.0044684C13.0522 0.00496859 13.049 0.00721943 13.0467 0.00821981L13.0505 0.00171737C10.6158 1.42725 9.78925 4.06574 9.71422 5.38624C9.82726 5.37848 9.9393 5.36898 10.0548 5.36898C10.9186 5.37065 11.7666 5.60101 12.5125 6.03664C13.2584 6.47227 13.8756 7.09764 14.3014 7.84916C13.6196 7.37691 12.7868 7.17468 11.9643 7.2817C15.4506 9.02485 14.5153 15.0271 9.68371 14.802C9.25351 14.7843 8.82838 14.7023 8.42248 14.5587C8.32761 14.5232 8.23275 14.4843 8.13788 14.4421C8.08311 14.4171 8.02834 14.3921 7.97432 14.3641L7.98107 14.3684C7.93405 14.3458 7.88703 14.3224 7.84002 14.2981C7.88528 14.3198 7.9278 14.3433 7.97432 14.3641C6.79062 13.7524 5.81326 12.5959 5.69121 11.1929C5.69121 11.1929 6.13863 9.52554 8.89491 9.52554C9.19277 9.52554 10.0453 8.69398 10.0606 8.45289C10.0568 8.37411 8.36996 7.7026 7.71222 7.05486C7.36084 6.70848 7.19402 6.54167 7.04622 6.41637C6.96634 6.34871 6.88285 6.28543 6.79612 6.2268C6.57529 5.45374 6.56588 4.6356 6.76886 3.85766C5.87474 4.29077 5.08027 4.90479 4.43574 5.66084H4.43124C4.04709 5.17391 4.0741 3.5683 4.09611 3.23293C3.98247 3.2786 3.87399 3.33619 3.77249 3.40474C3.43337 3.64677 3.11635 3.91835 2.82514 4.2163C2.49328 4.55275 2.19019 4.91641 1.91905 5.30345V5.30496V5.30321C1.29595 6.18644 0.853946 7.18434 0.618558 8.23931L0.605554 8.30333C0.587297 8.38861 0.505516 8.82177 0.493762 8.91481C0.418959 9.36194 0.371188 9.81318 0.350708 10.2661V10.3161C0.354992 12.7416 1.26845 15.0774 2.91076 16.8624C4.55307 18.6474 6.80488 19.7518 9.22168 19.9576C11.6385 20.1635 14.0446 19.4558 15.9652 17.9743C17.8857 16.4928 19.181 14.3451 19.5954 11.9552C19.6117 11.8302 19.6249 11.7064 19.6394 11.5801C19.8391 9.92991 19.623 8.25604 19.0107 6.71073L19.0112 6.71023ZM18.0496 7.20817L18.0513 7.21842L18.0496 7.20817Z"
        fill="url(#paint11_linear_927_5847)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_927_5847"
        x1="17.728"
        y1="3.09786"
        x2="1.63621"
        y2="18.6237"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.048" stopColor="#FFF44F" />
        <stop offset="0.111" stopColor="#FFE847" />
        <stop offset="0.225" stopColor="#FFC830" />
        <stop offset="0.368" stopColor="#FF980E" />
        <stop offset="0.401" stopColor="#FF8B16" />
        <stop offset="0.462" stopColor="#FF672A" />
        <stop offset="0.534" stopColor="#FF3647" />
        <stop offset="0.705" stopColor="#E31587" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.1052 2.25108) scale(20.2076)"
      >
        <stop offset="0.129" stopColor="#FFBD4F" />
        <stop offset="0.186" stopColor="#FFAC31" />
        <stop offset="0.247" stopColor="#FF9D17" />
        <stop offset="0.283" stopColor="#FF980E" />
        <stop offset="0.403" stopColor="#FF563B" />
        <stop offset="0.467" stopColor="#FF3750" />
        <stop offset="0.71" stopColor="#F5156C" />
        <stop offset="0.782" stopColor="#EB0878" />
        <stop offset="0.86" stopColor="#E50080" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.6024 10.5042) scale(20.2076)"
      >
        <stop offset="0.3" stopColor="#960E18" />
        <stop offset="0.351" stopColor="#B11927" stopOpacity="0.74" />
        <stop offset="0.435" stopColor="#DB293D" stopOpacity="0.343" />
        <stop offset="0.497" stopColor="#F5334B" stopOpacity="0.094" />
        <stop offset="0.53" stopColor="#FF3750" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint3_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.1034 -2.25084) scale(14.638)"
      >
        <stop offset="0.132" stopColor="#FFF44F" />
        <stop offset="0.252" stopColor="#FFDC3E" />
        <stop offset="0.506" stopColor="#FF9D12" />
        <stop offset="0.526" stopColor="#FF980E" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.35173 15.7558) scale(9.62111)"
      >
        <stop offset="0.353" stopColor="#3A8EE6" />
        <stop offset="0.472" stopColor="#5C79F0" />
        <stop offset="0.669" stopColor="#9059FF" />
        <stop offset={1} stopColor="#C139E6" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.5799 8.76923) rotate(-13.5916) scale(5.10194 5.97309)"
      >
        <stop offset="0.206" stopColor="#9059FF" stopOpacity={0} />
        <stop offset="0.278" stopColor="#8C4FF3" stopOpacity="0.064" />
        <stop offset="0.747" stopColor="#7716A8" stopOpacity="0.45" />
        <stop offset="0.975" stopColor="#6E008B" stopOpacity="0.6" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.35238 1.50057) scale(6.9226)"
      >
        <stop stopColor="#FFE226" />
        <stop offset="0.121" stopColor="#FFDB27" />
        <stop offset="0.295" stopColor="#FFC82A" />
        <stop offset="0.502" stopColor="#FFA930" />
        <stop offset="0.732" stopColor="#FF7E37" />
        <stop offset="0.792" stopColor="#FF7139" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.8545 -3.00121) scale(29.5361)"
      >
        <stop offset="0.113" stopColor="#FFF44F" />
        <stop offset="0.456" stopColor="#FF980E" />
        <stop offset="0.622" stopColor="#FF5634" />
        <stop offset="0.716" stopColor="#FF3647" />
        <stop offset="0.904" stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.3996 -1.36343) rotate(83.976) scale(21.6445 14.2051)"
      >
        <stop stopColor="#FFF44F" />
        <stop offset="0.06" stopColor="#FFE847" />
        <stop offset="0.168" stopColor="#FFC830" />
        <stop offset="0.304" stopColor="#FF980E" />
        <stop offset="0.356" stopColor="#FF8B16" />
        <stop offset="0.455" stopColor="#FF672A" />
        <stop offset="0.57" stopColor="#FF3647" />
        <stop offset="0.737" stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.35233 4.00165) scale(18.4369)"
      >
        <stop offset="0.137" stopColor="#FFF44F" />
        <stop offset="0.48" stopColor="#FF980E" />
        <stop offset="0.592" stopColor="#FF5634" />
        <stop offset="0.655" stopColor="#FF3647" />
        <stop offset="0.904" stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_927_5847"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.1041 5.00184) scale(20.1801)"
      >
        <stop offset="0.094" stopColor="#FFF44F" />
        <stop offset="0.231" stopColor="#FFE141" />
        <stop offset="0.509" stopColor="#FFAF1E" />
        <stop offset="0.626" stopColor="#FF980E" />
      </radialGradient>
      <linearGradient
        id="paint11_linear_927_5847"
        x1="17.5331"
        y1="3.01533"
        x2="3.84302"
        y2="16.708"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.167" stopColor="#FFF44F" stopOpacity="0.8" />
        <stop offset="0.266" stopColor="#FFF44F" stopOpacity="0.634" />
        <stop offset="0.489" stopColor="#FFF44F" stopOpacity="0.217" />
        <stop offset="0.6" stopColor="#FFF44F" stopOpacity={0} />
      </linearGradient>
      <clipPath id="clip0_927_5847">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const Brave = (
  <svg
    aria-hidden="true"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2924 5.22043L17.7256 4.15905L16.4982 2.8883C15.8339 2.22404 14.4187 2.61393 14.4187 2.61393L12.8158 0.794434H7.16242L5.55231 2.62115C5.55231 2.62115 4.13715 2.23848 3.47289 2.8883L2.24545 4.15183L2.67866 5.21321L2.13715 6.78721L3.9422 13.6681C4.31765 15.141 4.57036 15.7114 5.63173 16.4623L8.93137 18.7006C9.24906 18.8955 9.63895 19.2349 9.99274 19.2349C10.3465 19.2349 10.7364 18.8955 11.0541 18.7006L14.3538 16.4623C15.4151 15.7114 15.6678 15.141 16.0433 13.6681L17.8483 6.78721L17.2924 5.22043Z"
      fill="url(#paint0_linear_927_5861)"
    />
    <path
      d="M13.9711 3.78343C13.9711 3.78343 16.0433 6.28884 16.0433 6.81592C16.0433 7.35744 15.7834 7.49462 15.5234 7.77621L13.9711 9.43686C13.8267 9.58126 13.5162 9.82675 13.6967 10.2527C13.8772 10.686 14.1299 11.2203 13.8411 11.769C13.5523 12.3249 13.0469 12.6932 12.722 12.6354C12.2387 12.4786 11.7777 12.2602 11.3502 11.9856C11.0758 11.8051 10.1949 11.0758 10.1949 10.7943C10.1949 10.5127 11.1047 10 11.278 9.89895C11.444 9.78343 12.2166 9.33577 12.231 9.16249C12.2455 8.9892 12.2455 8.94588 12.0144 8.51267C11.7834 8.07946 11.379 7.50184 11.4368 7.12639C11.509 6.75094 12.1588 6.54877 12.6426 6.36827L14.1372 5.80509C14.2527 5.74733 14.2238 5.69679 13.8772 5.66068C13.5307 5.6318 12.5559 5.50184 12.1155 5.62458C11.6751 5.74733 10.9386 5.93505 10.8664 6.03614C10.8086 6.13722 10.7509 6.13722 10.8159 6.48379L11.2346 8.75816C11.2635 9.04697 11.3213 9.24191 11.018 9.31411C10.7003 9.38632 10.1733 9.50906 9.99276 9.50906C9.81225 9.50906 9.27796 9.38632 8.96749 9.31411C8.65702 9.24191 8.71478 9.04697 8.75088 8.75816C8.77976 8.46935 9.09745 6.82314 9.16243 6.48379C9.23464 6.13722 9.16965 6.13722 9.11189 6.03614C9.03969 5.93505 8.29601 5.74733 7.85558 5.62458C7.42236 5.50184 6.44041 5.6318 6.09384 5.66791C5.74727 5.69679 5.71839 5.74011 5.83391 5.81231L7.3285 6.36827C7.80503 6.54877 8.46929 6.75094 8.53428 7.12639C8.60648 7.50906 8.19493 8.07946 7.95666 8.51267C7.71839 8.94588 7.72561 8.9892 7.74005 9.16249C7.75449 9.33577 8.53428 9.78343 8.69312 9.89895C8.86641 10.0073 9.77615 10.5127 9.77615 10.7943C9.77615 11.0758 8.91695 11.8051 8.62814 11.9856C8.20063 12.2602 7.73957 12.4786 7.2563 12.6354C6.93139 12.6932 6.42597 12.3249 6.12994 11.769C5.84113 11.2203 6.10106 10.686 6.27435 10.2527C6.45485 9.81953 6.1516 9.58848 5.99998 9.43686L4.44763 7.77621C4.19493 7.50906 3.935 7.36466 3.935 6.83036C3.935 6.29606 6.0072 3.79787 6.0072 3.79787L7.97832 4.11556C8.20937 4.11556 8.722 3.92061 9.19132 3.75455C9.66063 3.61014 9.98554 3.5957 9.98554 3.5957C9.98554 3.5957 10.3032 3.5957 10.7798 3.75455C11.2563 3.91339 11.7617 4.11556 11.9928 4.11556C12.231 4.11556 13.9783 3.77621 13.9783 3.77621L13.9711 3.78343ZM12.4188 13.3719C12.5487 13.4441 12.4693 13.6029 12.3465 13.6896L10.5126 15.1192C10.3682 15.2636 10.1372 15.4802 9.98554 15.4802C9.83391 15.4802 9.61009 15.2636 9.45846 15.1192C8.8506 14.6351 8.23683 14.1586 7.61731 13.6896C7.50178 13.6029 7.42236 13.4513 7.54511 13.3719L8.62814 12.7943C9.05864 12.5665 9.51417 12.3897 9.98554 12.2672C10.0938 12.2672 10.7798 12.5127 11.3357 12.7943L12.4188 13.3719Z"
      fill="white"
    />
    <path
      d="M14.4332 2.62115L12.8159 0.794434H7.16243L5.55232 2.62115C5.55232 2.62115 4.13716 2.23848 3.4729 2.8883C3.4729 2.8883 5.35016 2.72223 5.99998 3.77638L7.99276 4.11573C8.2238 4.11573 8.73644 3.92079 9.20575 3.75472C9.67507 3.61032 9.99998 3.59588 9.99998 3.59588C9.99998 3.59588 10.3177 3.59588 10.7942 3.75472C11.2707 3.91357 11.7761 4.11573 12.0072 4.11573C12.2455 4.11573 13.9928 3.77638 13.9928 3.77638C14.6426 2.72223 16.5198 2.8883 16.5198 2.8883C15.8556 2.22404 14.4404 2.61393 14.4404 2.61393"
      fill="url(#paint1_linear_927_5861)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_927_5861"
        x1="2.13715"
        y1="10.1991"
        x2="17.8483"
        y2="10.1991"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.4" stopColor="#FF5500" />
        <stop offset="0.6" stopColor="#FF2000" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_927_5861"
        x1="3.73384"
        y1="2.4883"
        x2="16.5198"
        y2="2.4883"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF452A" />
        <stop offset={1} stopColor="#FF2000" />
      </linearGradient>
    </defs>
  </svg>
);
const Edge = (
  <svg
    aria-hidden="true"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_927_5865)">
      <path
        d="M18.0547 14.8828C17.7865 15.0222 17.5099 15.1448 17.2266 15.25C16.3293 15.584 15.3792 15.7533 14.4219 15.75C10.7266 15.75 7.50781 13.2109 7.50781 9.94531C7.51262 9.50803 7.63385 9.07993 7.85905 8.70506C8.08424 8.33019 8.40526 8.0221 8.78906 7.8125C5.44531 7.95312 4.58594 11.4375 4.58594 13.4766C4.58594 19.2578 9.90625 19.8359 11.0547 19.8359C11.6719 19.8359 12.6016 19.6562 13.1641 19.4766L13.2656 19.4453C15.4183 18.7014 17.2534 17.2465 18.4688 15.3203C18.5041 15.2618 18.5192 15.1933 18.5119 15.1253C18.5046 15.0574 18.4752 14.9937 18.4282 14.944C18.3812 14.8944 18.3192 14.8615 18.2518 14.8505C18.1843 14.8394 18.1151 14.8508 18.0547 14.8828Z"
        fill="url(#paint0_linear_927_5865)"
      />
      <path
        opacity="0.35"
        d="M18.0547 14.8828C17.7865 15.0222 17.5099 15.1448 17.2266 15.25C16.3293 15.584 15.3792 15.7533 14.4219 15.75C10.7266 15.75 7.50781 13.2109 7.50781 9.94531C7.51262 9.50803 7.63385 9.07993 7.85905 8.70506C8.08424 8.33019 8.40526 8.0221 8.78906 7.8125C5.44531 7.95312 4.58594 11.4375 4.58594 13.4766C4.58594 19.2578 9.90625 19.8359 11.0547 19.8359C11.6719 19.8359 12.6016 19.6562 13.1641 19.4766L13.2656 19.4453C15.4183 18.7014 17.2534 17.2465 18.4688 15.3203C18.5041 15.2618 18.5192 15.1933 18.5119 15.1253C18.5046 15.0574 18.4752 14.9937 18.4282 14.944C18.3812 14.8944 18.3192 14.8615 18.2518 14.8505C18.1843 14.8394 18.1151 14.8508 18.0547 14.8828Z"
        fill="url(#paint1_radial_927_5865)"
      />
      <path
        d="M8.2578 18.8516C7.56239 18.4196 6.95961 17.854 6.48436 17.1875C5.94166 16.4447 5.56809 15.5921 5.38987 14.6896C5.21165 13.787 5.23311 12.8565 5.45272 11.9631C5.67234 11.0697 6.08479 10.2353 6.66115 9.51826C7.23751 8.80123 7.96379 8.21903 8.78905 7.8125C9.03905 7.69531 9.45311 7.49219 10.0078 7.5C10.3981 7.50302 10.7824 7.59627 11.1308 7.77245C11.4791 7.94864 11.7819 8.20299 12.0156 8.51562C12.3299 8.93835 12.5023 9.4498 12.5078 9.97656C12.5078 9.96094 14.4219 3.75781 6.2578 3.75781C2.82811 3.75781 0.00780015 7.00781 0.00780015 9.86719C-0.00584162 11.3776 0.317079 12.8721 0.953112 14.2422C1.99473 16.4602 3.81447 18.2185 6.06689 19.1834C8.3193 20.1483 10.8476 20.2526 13.1719 19.4766C12.3576 19.7337 11.4972 19.811 10.6501 19.7031C9.80297 19.5952 8.98941 19.3047 8.26561 18.8516H8.2578Z"
        fill="url(#paint2_linear_927_5865)"
      />
      <path
        opacity="0.41"
        d="M8.2578 18.8516C7.56239 18.4196 6.95961 17.854 6.48436 17.1875C5.94166 16.4447 5.56809 15.5921 5.38987 14.6896C5.21165 13.787 5.23311 12.8565 5.45272 11.9631C5.67234 11.0697 6.08479 10.2353 6.66115 9.51826C7.23751 8.80123 7.96379 8.21903 8.78905 7.8125C9.03905 7.69531 9.45311 7.49219 10.0078 7.5C10.3981 7.50302 10.7824 7.59627 11.1308 7.77245C11.4791 7.94864 11.7819 8.20299 12.0156 8.51562C12.3299 8.93835 12.5023 9.4498 12.5078 9.97656C12.5078 9.96094 14.4219 3.75781 6.2578 3.75781C2.82811 3.75781 0.00780015 7.00781 0.00780015 9.86719C-0.00584162 11.3776 0.317079 12.8721 0.953112 14.2422C1.99473 16.4602 3.81447 18.2185 6.06689 19.1834C8.3193 20.1483 10.8476 20.2526 13.1719 19.4766C12.3576 19.7337 11.4972 19.811 10.6501 19.7031C9.80297 19.5952 8.98941 19.3047 8.26561 18.8516H8.2578Z"
        fill="url(#paint3_radial_927_5865)"
      />
      <path
        d="M11.9062 11.625C11.8359 11.7031 11.6406 11.8203 11.6406 12.0625C11.6406 12.2656 11.7734 12.4688 12.0156 12.6328C13.1328 13.4141 15.25 13.3047 15.2578 13.3047C16.0907 13.3041 16.9081 13.0802 17.625 12.6562C18.3467 12.2341 18.9456 11.6307 19.3622 10.9057C19.7788 10.1808 19.9986 9.35955 20 8.52344C20.0234 6.77344 19.375 5.60937 19.1172 5.09375C17.4531 1.85937 13.8828 4.89564e-08 10 4.89564e-08C7.37202 -0.00025981 4.84956 1.03398 2.97819 2.87904C1.10682 4.7241 0.0369559 7.23166 0 9.85938C0.0390625 7.00781 2.875 4.70312 6.25 4.70312C6.52344 4.70312 8.08594 4.72656 9.53125 5.48438C10.5466 5.98895 11.3875 6.78627 11.9453 7.77344C12.4219 8.60156 12.5078 9.65625 12.5078 10.0781C12.5078 10.5 12.2969 11.1172 11.8984 11.6328L11.9062 11.625Z"
        fill="url(#paint4_radial_927_5865)"
      />
      <path
        d="M11.9062 11.625C11.8359 11.7031 11.6406 11.8203 11.6406 12.0625C11.6406 12.2656 11.7734 12.4688 12.0156 12.6328C13.1328 13.4141 15.25 13.3047 15.2578 13.3047C16.0907 13.3041 16.9081 13.0802 17.625 12.6562C18.3467 12.2341 18.9456 11.6307 19.3622 10.9057C19.7788 10.1808 19.9986 9.35955 20 8.52344C20.0234 6.77344 19.375 5.60937 19.1172 5.09375C17.4531 1.85937 13.8828 4.89564e-08 10 4.89564e-08C7.37202 -0.00025981 4.84956 1.03398 2.97819 2.87904C1.10682 4.7241 0.0369559 7.23166 0 9.85938C0.0390625 7.00781 2.875 4.70312 6.25 4.70312C6.52344 4.70312 8.08594 4.72656 9.53125 5.48438C10.5466 5.98895 11.3875 6.78627 11.9453 7.77344C12.4219 8.60156 12.5078 9.65625 12.5078 10.0781C12.5078 10.5 12.2969 11.1172 11.8984 11.6328L11.9062 11.625Z"
        fill="url(#paint5_radial_927_5865)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_927_5865"
        x1="4.58594"
        y1="13.8281"
        x2="18.5234"
        y2="13.8281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0C59A4" />
        <stop offset={1} stopColor="#114A8B" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_927_5865"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.2813 13.9332) scale(7.45313 7.08047)"
      >
        <stop offset="0.7" stopOpacity={0} />
        <stop offset="0.9" stopOpacity="0.5" />
        <stop offset={1} />
      </radialGradient>
      <linearGradient
        id="paint2_linear_927_5865"
        x1="11.9297"
        y1="7.78125"
        x2="3.23436"
        y2="17.2578"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B9DE2" />
        <stop offset="0.2" stopColor="#1595DF" />
        <stop offset="0.7" stopColor="#0680D7" />
        <stop offset={1} stopColor="#0078D4" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_927_5865"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.51209 15.5419) rotate(-81.3844) scale(11.202 9.05011)"
      >
        <stop offset="0.8" stopOpacity={0} />
        <stop offset="0.9" stopOpacity="0.5" />
        <stop offset={1} />
      </radialGradient>
      <radialGradient
        id="paint4_radial_927_5865"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.02266 3.69656) rotate(92.2906) scale(15.8251 33.7043)"
      >
        <stop stopColor="#35C1F1" />
        <stop offset="0.1" stopColor="#34C1ED" />
        <stop offset="0.2" stopColor="#2FC2DF" />
        <stop offset="0.3" stopColor="#2BC3D2" />
        <stop offset="0.7" stopColor="#36C752" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_927_5865"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.7547 6.03906) rotate(73.7398) scale(7.60156 6.18159)"
      >
        <stop stopColor="#66EB6E" />
        <stop offset={1} stopColor="#66EB6E" stopOpacity={0} />
      </radialGradient>
      <clipPath id="clip0_927_5865">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default { Chrome, FireFox, Brave, Edge };
